import { APP_BASE_HREF } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@app/_core/services/app.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ChildComponent } from '../../case-detail.component';
import { Utils } from '@app/_core/helper/Utils';
import { MessageDialogComponent } from '@app/pages/common/message-dialog/message-dialog.component';
import { ManagerService } from '@app/_core/services/manager.service';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-create-case',
  templateUrl: './user-selection.component.html',
  styleUrl: './user-selection.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class UserSelectionComponent implements OnInit, ChildComponent {
  @Input() heading: any;
  @Input() reason: any;
  @Input() currentUserID: any;
  showCreateCase: boolean;
  showSearch: boolean;
  showAddUser: boolean;
  @ViewChild('input') input;
  
  @Output() selectedUserData = new EventEmitter<any>();
  fullName: any;
  userID: any;
  qnxtID: any;
  recordID: any;

  addMemberData = {
    Role: 1,
    Industry: 1,
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    submitOptions:'callLater'
  };
  submitted = false;
  modalRef?: BsModalRef;
  user: any;
  company: any;
  activityId: any;
  queueID: any;
  addNewUser: boolean = false;
  addedUserID: any;
  selectedCaseId: any;
  selectedUserID: any;
  searchedUserData: any;
  display: string = 'none';
  selectedFullName: any;
  clientAbbreviation: any;
  @ViewChildren('child') children: QueryList<ChildComponent>;
  formDataValid: boolean = true;
  selectedQnxtID: any;
  selectedRecordID: any;
  constructor(
    private router: Router,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private webStorageService: WebStorageService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private appService: AppService,
    private queueServices: QueuesService,
    private managerService: ManagerService
  ) {}
  getFormData() {
    throw new Error('Method not implemented.');
  }
  emitFormData() {
    throw new Error('Method not implemented.');
  }
  
  ngOnInit(): void {
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    this.showSearch = true;
    this.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.company = this.webStorageService.getItemFromSessionStorage('company');
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.appService.selectedQueueId.subscribe(queueId => {
      this.queueID = queueId;
    });
    this.addNewUser = this.appService.getIsAddNewUser();
  }
  handleSelectedUser(event) {
    if(event == 'not-found'){
       this.heading = 'Create New User';
        this.showAddUser = true;
        this.showSearch = false;
    }else if (event != null) {
      if (event[0].UserID != null && this.currentUserID == event[0].UserID) {
        const initialState = { message: 'This user is already selected. Please select a different user.' };
        const config: ModalOptions = {
          class: 'modal-sm modal-dialog-centered',
          ignoreBackdropClick: true,
          keyboard: false,
          initialState: initialState,
        };
      
        this.modalRef = this.modalService.show(MessageDialogComponent, config);
        this.modalRef.content.event?.subscribe((result: any) => {});
      }else{
        this.showCreateCase = true;
        this.selectedUserData.emit({
          userID: event[0].UserID,
          qnxtID: event[0].CrmUserID,
          recordID: event[0].ShortVanityID,
          fullName: event[0].FullName,
          role: event[0].Role,
        });
      }
    } else if (event == null) {
        this.showCreateCase = false;
        this.showSearch = true;
        this.heading = 'Select a User';
    }
  }

  changeUser() {
    this.showCreateCase = false;
    this.showSearch = true;
    this.heading = 'Select a User';
  }

  closeCaseCreation() {
    this.bsModalRef.hide();
  }
 
  cancel() {
    this.bsModalRef.hide();
  }
  handleSelectedUserNotFound(event) {
    if (event != null) {
      console.log('add-rec-cont');
      const initialState = {
        contentMsg: 'This will create a new user record. Are you sure you would like to continue?',
        confirmBtnValue: 'Ok',
        cancelBtnValue: 'Cancel',
        isConfirm: true,
        isDelete: false,
      };

      const config: ModalOptions = {
        backdrop: 'static',
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };

      this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
      this.modalRef.content.event.subscribe((result: any) => {
        if (result.value == 'confirm') {
          console.log('create');
          this.bsModalRef.hide();
         // const actionItem = this.getActionItem();
            const actionItem = this.queueServices.getselectedQueueId() + "-new_";
          this.appService.setActionItemId(actionItem);
          this.appService.setIsAddNewUser(true);
          //this.appService.setConfirmationStatus(true);
          this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails']);
        } else {
          this.bsModalRef.hide();
        }
        this.modalRef.hide();
      });
    }
  } 
  confirm(form: NgForm){
      this.submitted = true;
      if (form.invalid) { 
        return; 
       }
  
      const data = {
        userData: this.addMemberData,
        activityID: this.activityId,
        queueID: this.queueID,
        userID: this.selectedUserID,
        company: this.company,
        user: this.user,
      };
      this.managerService.addNewUser(data).subscribe(res => {
        const data = res?.Response?.Data;
        if(data && data.includes('-')){
          const value = data.split('-');
          this.addedUserID = value[value.length - 1];

          this.bsModalRef.hide();
          this.showCreateCase = true;
          this.selectedUserData.emit({
            userID: this.addedUserID,
            fullName: `${this.addMemberData?.FirstName || ''} ${this.addMemberData?.LastName || ''}`.trim(),
            qnxtID: '',
            recordID: '',
            role: 'Other',
          });
        }
      });
    }
}
